const tra = {
  MIN_VALUE: {
    message: 'Valor da transferência não pode ser R$0,00',
    field: 'value',
    code: 'TRA_1'
  },
  MAX_VALUE: {
    message: 'Valor desta transferência não pode ser superior à R${{maxValue}}',
    field: 'value',
    variable: 'maxValue',
    code: 'TRA_2'
  },
  FORMAT_ERROR: {
    message: 'Formato do conteúdo de algum campo está diferente do esperado',
    field: 'transfer',
    code: 'TRA_3'
  },
  PAYMENT_DATE_BEFORE_CURRENT_DATE: {
    message: 'Data de pagamento menor que a data atual',
    field: 'payment_date',
    code: 'TRA_4'
  },
  INVALID_TEV_PROCESSING_HOUR: {
    message: 'Agendamentos para hoje só são permitidos até as 19h',
    field: 'payment_date',
    code: 'TRA_5'
  },
  INVALID_TED_PROCESSING_HOUR: {
    message: 'Agendamentos de TED para hoje só são permitidos até as 16h30',
    field: 'payment_date',
    code: 'TRA_6'
  },
  MAX_PAYMENT_DATE: {
    message: 'Não é possível agendar transferências para mais de 30 dias',
    field: 'payment_date',
    code: 'TRA_7'
  },
  BUSINESS_DAY: {
    message: 'Essa data não é um dia útil, selecione um dia útil para ser pago',
    field: 'payment_date',
    code: 'TRA_8'
  },
  PAYMENT_DATE_WRONG_DATE_FORMAT: {
    message: 'Formato incorreto para a data de pagamento',
    field: 'payment_date',
    code: 'TRA_9'
  },
  NOT_SCHEDULED_OUT_OF_TIME: {
    message: 'Você possui pagamentos que serão realizados no próximo dia útil',
    field: 'payment_date',
    code: 'TRA_10'
  },
  DUPLICATED_INTEGRATION_ID: {
    message: 'ID de integração duplicado',
    field: 'integration_id',
    code: 'TRA_11'
  },
  DBA_REMOVED: {
    message: 'Recebedor está removido',
    field: 'destination_bank_account',
    code: 'TRA_12'
  },
  INVALID_PAYMENT_METHOD: {
    message: 'Método de pagamento inválido',
    field: 'payment_method',
    code: 'TRA_13'
  },
  CANT_SCHEDULE_PIX_PAYMENT_WITH_KEY: {
    message: 'Não é possível agendar pagamentos PIX com chave',
    field: 'payment_date',
    code: 'TRA_14'
  },
  MAX_DECIMAL_PLACES: {
    message: 'Valor da transferência não pode ter mais que 2 casas decimais',
    field: 'value',
    code: 'TRA_15'
  },
  INVALID_PIX_DESCRIPTION_LENGTH: {
    message: 'Descrição Pix não pode ser maior que 140 caracteres',
    field: 'pix_description',
    code: 'TRA_16'
  },
  INVALID_PIX_DESCRIPTION_FORMAT: {
    message: 'Descrição Pix com formato inválido',
    field: 'pix_description',
    code: 'TRA_17'
  },
  RECEIPT_BATCH_DOWNLOAD_LIMIT_EXCEEDED: {
    message:
      'Foram identificadas mais de {{maxTransfersAllowed}} transferências. Experimente aplicar mais filtros e tente novamente.',
    field: 'receipt_batch_download',
    variable: 'maxTransfersAllowed',
    code: 'TRA_18'
  },
  INVALID_IDEMPOTENCY_KEY: {
    message: 'Chave de idempotência inválida',
    field: 'idempotency_key',
    code: 'TRA_19'
  },
  DUPLICATED_IDEMPOTENCY_KEY: {
    message: 'Transferência(s) com chave de idempotência duplicada ({{duplicatedIdempotencyKeys}})',
    field: 'idempotency_key',
    variable: 'duplicatedIdempotencyKeys',
    code: 'TRA_20'
  }
};

module.exports = tra;
